import React, { memo, useCallback, isValidElement, CSSProperties } from 'react';
import { Mark as IMark } from '../types';
import { useTheme } from '../../styles';

export interface MarkProps {
	className: string;
	vertical: boolean;
	mark: IMark;
	point: number;
	lowerBound: number;
	range: number;
	active: boolean;
	onChange?: (point: number) => void;
}

function Mark({
	className,
	vertical,
	mark,
	point,
	lowerBound,
	range,
	active,
	onChange,
}: MarkProps) {
	const handleClick = useCallback(() => {
		if (onChange) {
			onChange(point);
		}
	}, [onChange, point]);
	const theme = useTheme();
	const markPointIsObject = (
		typeof mark === 'object' &&
		!isValidElement(mark)
	);
	const markLabel = markPointIsObject ? (mark as any).label : mark;
	const percentage = ((point - lowerBound) / range) * 100;
	const bottomStyle = {
		marginBottom: '-50%',
		bottom: `${percentage}%`,
	};
	const leftStyle = {
		left: `${percentage}%`,
		transform: `translateX(-50%)`,
		msTransform: `translateX(-50%)`,
	};
	let style: CSSProperties = vertical ? bottomStyle : leftStyle;
	style = active ?
		{ ...style, color: theme.color.text.B6 } :
		style;
	style = markPointIsObject ?
		{ ...style, ...(mark as any).style } :
		style;

	return (
		<span
			className={className}
			onMouseDown={handleClick}
			onTouchStart={handleClick}
			style={style}
		>
			{markLabel}
		</span>
	);
}

export default memo(Mark);
